import { Stage } from 'konva/types/Stage';
import { PointTuple } from 'modules/Canvas/components/Canvas/hooks/types';

type MediaDimensions =
  | {
      naturalHeight: number;
      naturalWidth: number;
    }
  | {
      videoHeight: number;
      videoWidth: number;
    };

/**
 * Convert konva friendly numbers to clarifai api friendly numbers
 */
export const getBoundingBoxData = (
  { x, y, width: w, height: h }: Record<'x' | 'y' | 'width' | 'height', number>,
  // need to check { height , width } for video
  media: MediaDimensions,
): CF.API.BoundingBox => {
  const height = 'naturalHeight' in media ? media.naturalHeight : media.videoHeight;
  const width = 'naturalWidth' in media ? media.naturalWidth : media.videoWidth;

  return {
    top_row: y / height,
    bottom_row: (y + h) / height,
    left_col: x / width,
    right_col: Math.min(1, (x + w) / width),
  };
};

/**
 * Convert konva friendly numbers to clarifai api friendly numbers
 */
export const getPolygonData = (pts: PointTuple[], media: MediaDimensions): CF.API.Polygon['points'] => {
  const height = 'naturalHeight' in media ? media.naturalHeight : media.videoHeight;
  const width = 'naturalWidth' in media ? media.naturalWidth : media.videoWidth;
  const points: CF.API.Polygon['points'] = pts.map(([col, row]) => ({
    col: col / width,
    row: row / height,
  }));

  return points;
};

export const removeShape = (stage: Stage, id: string) => {
  if (stage) {
    // Although it returns an array, the array should have just one node.
    const nodeToRemove = stage.find(`#${id}`)[0];

    if (nodeToRemove) {
      nodeToRemove.destroy();
      stage.draw();
    }
  }
};
